export default __webpack_public_path__ + "static/media/Sk-mage.f5011063.png";